import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'primeng/api';
import { AdicionalEDesconto } from 'src/app/admihair/api/dto/adicional-e-desconto';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Profissional } from 'src/app/admihair/api/dto/profissional';
import { AdicionalEDescontoService } from 'src/app/admihair/service/adicional-e-desconto.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { ProfissionalService } from 'src/app/admihair/service/profissional.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-adicionais-e-descontos-detalhar',
  templateUrl: './adicionais-e-descontos-detalhar.component.html',
  styleUrls: ['./adicionais-e-descontos-detalhar.component.scss']
})
export class AdicionaisEDescontosDetalharComponent implements OnInit {

  permissaoDetalhar: boolean = false;
  loading: boolean = true;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  empresaSelecionada?: Empresa;
  id?: number;
  adicionalEDesconto?: AdicionalEDesconto;
  profissionais: Profissional[] = [];

  constructor(private adicionalEDescontoService: AdicionalEDescontoService,
    private profissionalService: ProfissionalService,
    private utilStorageService: UtilStorageService,
    private erroService: ErroService,
    private activatedRouter: ActivatedRoute) { }

  ngOnInit(): void {
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_ADICIONAIS_E_DESCONTOS');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    this.carregarId();
    if (this.permissaoDetalhar) {
      this.carregarProfissionais();
    }
  }

  carregar(){
    this.adicionalEDescontoService.buscarPorId(this.id).subscribe({
      next: (data: AdicionalEDesconto) => {
        this.adicionalEDesconto = data;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    })
  }

  carregarProfissionais(){
    this.profissionalService.listarAtivosPorEmpresaId(this.empresaSelecionada?.id).subscribe({
      next: (data: Profissional[]) => {
        this.profissionais = data;
        this.carregar();
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    })
  }

  exibirNomeProfissional(id?: number): string | undefined {
    const nomeProfissional = this.profissionais.find(prof => prof.id === id)?.usuario?.nome;
    
    return nomeProfissional; 
  }

  carregarId(){
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if(idParam){
      this.id = parseInt(idParam);
    }
  }


  verificarPermissao(nome: string): boolean{
    return AuthUtil.verificarPermissao(nome);
  }

}
